import { createRouter, createWebHistory } from 'vue-router'

import { createAuthGuard } from './guards'
import { routes } from './routes'

export const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior() {
    return { top: 0 }
  },
})

// Registered here (not in main.ts) so the guard module stays the single
// place that owns the auth/RBAC navigation contract. Pinia must already be
// installed on the app by the time this guard runs — see main.ts, which
// calls `app.use(pinia)` before `app.use(router)`.
router.beforeEach(createAuthGuard())

export type { NavItem } from './nav-items'
export { NAV_ITEMS } from './nav-items'
